// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"AttachmentAddZone_dropzone__3J8zx","wrapper":"AttachmentAddZone_wrapper__3f8M-"};